import { axios, identityActions } from '@figure/frontlib-onboarding-redux';
import { isLocalhost } from 'shared/utils';
import { default as store } from '../store';

/**
 * Initializes the Authorization header for axios and intercepts all API responses to ensure that our Authorization token stays
 * up-to-date.
 * @param {String} jwt Authorization token to be sent in every axios request.
 */
export const setupAuthInterceptor = (jwt) => {
  if (jwt) {
    axios.defaults.headers.common.Authorization = jwt;
  }

  axios.interceptors.response.use(
    (response) => {
      if (response.status === 200) {
        const { authorization } = response.headers;

        if (typeof authorization === 'string' && authorization.indexOf('Bearer ') === 0) {
          store.dispatch(identityActions.rotateJwt({ jwt: authorization }));
        }
      }

      return response;
    },
    (error) => {
      // Have to check error object existence due to possibility of cancelations.
      if (
        (error?.response?.status === 403 && error?.response?.data?.message?.toUpperCase() === 'UNAUTHENTICATED') ||
        error?.response?.status === 401
      ) {
        store.dispatch(identityActions.timeout());
        window.location.href = isLocalhost() ? '/applications/start' : process.env.REACT_APP_LOGIN_PATH;
      }

      return Promise.reject(error);
    }
  );
};
